import { useResponsiveValue } from "../../styling";
import { forwardRef } from "react";
import { Flex, useFlexAlignment } from "./Flex";
import { mergeProps } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerStack({
  alignX,
  alignY,
  as = DefaultElement,
  children,
  forwardedRef,
  gap = 5,
  wrap,
  ...rest
}) {
  const alignXValue = useResponsiveValue(alignX);
  const alignYValue = useResponsiveValue(alignY);
  const wrapValue = useResponsiveValue(wrap);
  const alignProps = useFlexAlignment({
    alignX: alignXValue,
    alignY: alignYValue,
    orientation: "vertical"
  });
  return /*#__PURE__*/_jsx(Flex, { ...mergeProps(rest, {
      as,
      gap,
      ref: forwardedRef,
      wrap: wrapValue ? "wrap" : undefined
    }, alignProps),
    children: children
  });
}
InnerStack.defaultElement = DefaultElement;
export const Stack = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerStack, { ...props,
  forwardedRef: ref
}));